/*@ngInject*/
const OptionGroupTextInputController = function ($rootScope, $element, $uibModal, localization, configurationConstant,
                                                 configurationMediator, modalUtil, inputType) {

    $element.addClass('optionGroupTextInput');

    localization.getTranslationByKey('optionGroupTextInput').then(function (translations) {

        var currentValue;

        this.init = function () {
            currentValue = this.value;

            if (this.inputType === inputType.NUMBER) {
                this.type = 'number';
            } else {
                this.type = 'text';
            }
        };

        this.handleChange = function () {

                var fieldTemplateId = this.selectedField.fieldTemplate.id,
                    variableName = this.selectedField.fieldTemplate.variableName,
                    isNumericValue = this.inputType === inputType.NUMBER,
                    isNegativeNumericValue = _.indexOf(this.value, '-') !== -1,
                    isNumberRange = this.selectedField.fieldTemplate.validator === 'number range',
                    isPercent = this.selectedField.fieldTemplate.validator === 'percent';
                

                if (isNumericValue && isNegativeNumericValue && !isNumberRange && !isPercent) {
                    this.value = '0';
                }
                
                if (this.trim) {
                    this.value = _.trim(this.value);
                }

            if (currentValue !== this.value) {

                if(this.name === 'variableName' && this.selectedFieldStructure.originalVariableName === currentValue) {
                    configurationMediator.getFieldReferences(fieldTemplateId).then(function(fieldTemplateReferences){
                        if(fieldTemplateReferences.length > 0) {
                            modalUtil.openFieldReferencesModal('fieldReferencesConfirmVariableChange', fieldTemplateReferences, variableName, true).then(function (isConfirmed) {
                                if(isConfirmed){
                                    this.broadcastInputValueChange();
                                }
                                else{
                                    this.value = currentValue;
                                }
                            }.bind(this));
                        }
                        else{
                            this.broadcastInputValueChange();
                        }
                    }.bind(this));
                }
                else{
                    this.broadcastInputValueChange();
                }
            }
        };

        this.broadcastInputValueChange = function(){
            currentValue = this.value;

            $rootScope.$broadcast(configurationConstant.event.OPTION_GROUP_INPUT_VALUE_CHANGED, {
                name: this.name,
                value: this.value
            });
        };

        this.init();
    }.bind(this));
};

angular.module('ums.configuration')
    .controller('optionGroupTextInputController', OptionGroupTextInputController);
